import split from 'lodash/split';
import { interactionHistoryActions } from '../actions';
import { interactionHistorySelectors } from '../selectors';

const isNoMatch = (current, next) =>
  current !== next && split(current, '-')[0] !== next;

const updatePage = (state, action) => {
  const trace = [...(state.trace || [])];

  let { lastPage, lastSegment } =
    interactionHistorySelectors.getLastTraceEntries(trace);

  if (isNoMatch(lastSegment.name, action.segmentName)) {
    lastSegment = { name: action.segmentName, pages: [] };
    trace.push(lastSegment);
  }

  if (isNoMatch(lastPage.name, action.pageName) && !!lastSegment.pages) {
    lastPage = { name: action.pageName, fields: [] };
    lastSegment.pages.push(lastPage);
  }

  return {
    currentSegmentName: lastSegment.name,
    currentPageName: lastPage.name,
    trace,
  };
};

const normaliseField = field => {
  // When validating the error trace object,
  // Unable to determine shape of custom inputs from config.
  // Remove any extra field information.
  let normalisedField = field.split('-')[0];
  // Field names with .# due to addAnother are an unknown quantity.
  // Replace with .items
  normalisedField = normalisedField.replace(/\.[0-9]+/g, '.items');

  return normalisedField;
};

const updateField = (state, action) => {
  const trace = [...state.trace];

  let { lastField, lastPage } =
    interactionHistorySelectors.getLastTraceEntries(trace);

  const fieldName = normaliseField(action.fieldName);

  if (isNoMatch(lastField, fieldName)) {
    lastPage.fields.push(fieldName);
  }

  return {
    ...state,
    trace,
  };
};

export default (
    initialState = {
      currentSegmentName: '',
      currentPageName: '',
      trace: [],
    }
  ) =>
  (state = initialState, action) => {
    switch (action.type) {
      case interactionHistoryActions.NAVIGATE_PAGE:
        return updatePage(state, action);

      case interactionHistoryActions.UPDATE_FIELD:
        return updateField(state, action);

      default:
        return state;
    }
  };
